import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Phone, Calendar, Star } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-147">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-148"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-[#FF9500]/10 to-transparent rounded-full blur-3xl pointer-events-none" data-id="element-149"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center flex flex-col items-center py-20" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm mb-8" data-id="element-151">
          <ShieldCheck className="w-4 h-4 text-[#FFD600]" data-id="element-152" />
          <span className="text-xs font-bold tracking-wider text-[#FFD600] uppercase" data-id="element-153">
            Gas Safe Registered Engineers
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-5xl md:text-7xl lg:text-8xl font-black text-white leading-[1.1] tracking-tight mb-6" data-id="element-154">
          Trusted Gas Safe <br data-id="element-155" />
          Heating Experts <br data-id="element-156" />
          <span className="text-gradient" data-id="element-157">In Your Area</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-158">
          Fast, Reliable & Affordable Heating Solutions. From emergency boiler
          repairs to full central heating installations across Glasgow and
          Clydeside.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex flex-col sm:flex-row items-center gap-4 mb-16 w-full sm:w-auto" data-id="element-159">
          <a href="tel:07845242803" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-gradient-primary text-black font-bold text-lg px-8 py-4 rounded-full hover:shadow-[0_0_30px_rgba(255,149,0,0.3)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-160">
            <Phone className="w-5 h-5" data-id="element-161" />
            Call Now
          </a>
          <a href="#contact" className="w-full sm:w-auto flex items-center justify-center gap-2 border-2 border-[#FFD600] text-[#FFD600] font-bold text-lg px-8 py-4 rounded-full hover:bg-[#FFD600]/10 transition-all duration-300 transform hover:-translate-y-1" data-id="element-162">
            <Calendar className="w-5 h-5" data-id="element-163" />
            Get a Free Quote
          </a>
        </motion.div>

        {/* Featured Brand Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="relative w-full mb-16" data-id="element-164">
          <motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} data-id="element-165">
            <div className="absolute inset-0 bg-gradient-primary rounded-3xl blur-[40px] opacity-20" data-id="element-166"></div>
            <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-brand-card shadow-2xl shadow-black/50" data-id="element-167">
              <img src="https://cdn.magicpatterns.com/uploads/8VGZGHKHtDi3KJnSDpYPT4/ChatGPT_Image_Jun_4,_2026,_11_49_30_PM.png" alt="Clydeside Gas Safe Heating — Professional Gas Safe Heating Services" className="w-full h-auto object-cover block" data-id="element-168" />
            </div>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="w-full max-w-3xl border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-8" data-id="element-169">
          <div className="text-center" data-id="element-170">
            <div className="text-3xl font-black text-white mb-1" data-id="element-171">5+</div>
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-widest" data-id="element-172">
              Years Experience
            </div>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/10" data-id="element-173"></div>
          <div className="text-center" data-id="element-174">
            <div className="text-3xl font-black text-white mb-1" data-id="element-175">24/7</div>
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-widest" data-id="element-176">
              Emergency Callout
            </div>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/10" data-id="element-177"></div>
          <div className="text-center" data-id="element-178">
            <div className="text-3xl font-black text-white mb-1" data-id="element-179">5.0</div>
            <div className="flex items-center justify-center gap-1 mb-1" data-id="element-180">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#FFD600] text-[#FFD600]" data-id="element-181" />)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}